module.exports = __webpack_public_path__ + "img/BlinkArt_Mace2H_Medium.d8429093.png";